import React from "react";
import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";
import { render, NODE_PARAGRAPH } from "storyblok-rich-text-react-renderer";


const SeminarangebotOffering = ({ blok }) => (


    <div className="seminaroffering-wrap flex" style={{ display: `${blok.none}`}}>
      <div
        className="offering-wrap flex flex-col items-center justify-center"
        {...storyblokEditable(blok)}
      >
        {/* <img className="offering-img" src="/src/backgrounddesk.jpg" alt="" /> */}
        <img className="offering-img" src={blok.image.filename} alt={blok.image.alt} />
        <span className="offering-date">{blok.info}</span>
        <h2 className="text-2xl merriweather">{blok.subheadline}</h2>
        <p className="info-text">{blok.infotext}</p>


        <div className="info-text-struktur">
          {render(blok.infotextstructure, {
            nodeResolvers: {
              [NODE_PARAGRAPH]: (children) => (
                <div className="info-text-inner">
                  <img src="/src/circle-outline-white.png" className="dot"></img> {/* Hier kommt das extra <span> */}
                  <p>{children}</p>
                </div>
              ),
            },
          })}
        </div>
        {blok.link &&(<Link href={blok.link} target="_blank" >
            <button className="button-default">{blok.button}</button>
        </Link>)}
        {blok.buttonmail && (
          <a href={`mailto:${blok.empfaenger}?cc=${blok.empfaengerCC ? 'empfaengerCC' : ''}&subject=${blok.betreff}&body=Sehr geehrte Damen und Herren,%0D%0A%0D%0A ${blok.mailtext}%0D%0A%0D%0AMit freundlichen Grüßen`}>
          <button className="button-default">{blok.buttonmail}</button>
          </a>
        )}
      </div>
  </div>
);


export default SeminarangebotOffering;
